import Form from 'components/Profile/PersonalInfo/Form';

const PersonalInfo = () => <Form />;

export default PersonalInfo;
